export const replacePlaceholders = (text: string, speakerName: string): string => {
  return text.replace(/\{\{speakerName\}\}/g, speakerName);
};

export const getQuestionsWithSpeakerName = (speakerName: string) => {
  return defaultQuestions.map((question) => ({
    ...question,
    description: question.description ? replacePlaceholders(question.description, speakerName) : undefined,
  }));
};

export const getFullQuestions = (speakerName: string) => {
  return defaultQuestions.map((question) => ({
    ...question,
    description: question.description ? replacePlaceholders(question.description, speakerName) : undefined,
  }));
};

export const trialQuestions = [
  {
    priority: 1,
    label: 'Contact Information',
    type: 'contact',
    category: 'text',
    description: "Let's get your contact info",
    reportKey: 'contact_information',
    options: [
      { label: 'Ask for Attendee Email', inputLabel: 'Email', inputType: 'email', placeholder: 'Enter your email', required: true },
      { label: 'Ask for Attendee Name', inputLabel: 'Name', inputType: 'text', placeholder: 'Enter your name', required: true },
      { label: 'Ask for Phone Number', inputLabel: 'Phone Number', inputType: 'tel', placeholder: 'Enter your phone number', required: false },
      { label: 'I am speaking to an audience under 18', placeholder: 'Email and Name disabled - please confirm you are over 18', required: false, isUnder18Option: true },
    ],
    canSkip: false,
    isAnswerPublic: true,
    isDefault: false,
    isMovable: false,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 2,
    label: 'How valuable was this session?',
    type: 'rating',
    category: 'scale',
    description: 'How valuable was this session for you personally?',
    reportKey: 'session_value',
    options: ['Not valuable', 'Somewhat valuable', 'Valuable', 'Very valuable', 'Extremely valuable'],
    canSkip: true,
    isAnswerPublic: true,
    isDefault: true,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 3,
    label: 'Did you take away something applicable?',
    type: 'rating',
    category: 'scale',
    description: 'Did you take away something you can apply immediately?',
    reportKey: 'immediate_application',
    options: ['Not really', 'Somewhat', 'Yes, definitely', 'Absolutely — already planning to'],
    canSkip: true,
    isAnswerPublic: true,
    isDefault: true,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 4,
    label: 'How engaged did you feel?',
    type: 'rating',
    category: 'scale',
    description: 'How engaged did you feel during the session?',
    reportKey: 'engagement_level',
    options: ['Not engaged', 'Somewhat engaged', 'Engaged', 'Deeply engaged', 'Completely absorbed'],
    canSkip: true,
    isAnswerPublic: true,
    isDefault: true,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 5,
    label: 'How relevant was this topic?',
    type: 'rating',
    category: 'scale',
    description: 'How relevant was this topic to your work, business, or life right now?',
    reportKey: 'topic_relevance',
    options: ['Not relevant', 'Somewhat relevant', 'Relevant', 'Highly relevant', 'Perfectly timed'],
    canSkip: true,
    isAnswerPublic: true,
    isDefault: true,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 6,
    label: 'What idea will stay with you?',
    type: 'text',
    category: 'text',
    description: "What's one idea, insight, or moment that will stay with you from this session?",
    reportKey: 'memorable_insight',
    canSkip: true,
    isAnswerPublic: true,
    isDefault: true,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 7,
    label: 'How likely to recommend?',
    type: 'rating',
    category: 'nps',
    description: 'How likely are you to recommend this speaker to others?',
    reportKey: 'recommendation_likelihood',
    options: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    canSkip: true,
    isAnswerPublic: true,
    isDefault: true,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 8,
    label: 'Describe speaker style',
    type: 'text',
    category: 'text',
    description: "If you had to describe this speaker's style in one word, what would it be?",
    reportKey: 'speaker_style',
    canSkip: true,
    isAnswerPublic: true,
    isDefault: true,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
];

export const defaultQuestions = [
  {
    priority: 1,
    label: 'Contact Information',
    type: 'contact',
    category: 'text',
    description: "Let's get your contact info",
    reportKey: 'contact_information',
    options: [
      { label: 'Ask for Attendee Email', inputLabel: 'Email', inputType: 'email', placeholder: 'Enter your email', required: true },
      { label: 'Ask for Attendee Name', inputLabel: 'Name', inputType: 'text', placeholder: 'Enter your name', required: true },
      { label: 'Ask for Phone Number', inputLabel: 'Phone Number', inputType: 'tel', placeholder: 'Enter your phone number', required: false },
      { label: 'I am speaking to an audience under 18', placeholder: 'Email and Name disabled - please confirm you are over 18', required: false, isUnder18Option: true },
    ],
    canSkip: false,
    isAnswerPublic: true,
    isDefault: false,
    isMovable: false,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 2,
    label: 'How valuable was this session?',
    type: 'rating',
    category: 'scale',
    description: 'How valuable was this session for you personally?',
    reportKey: 'session_value',
    options: ['Not valuable', 'Somewhat valuable', 'Valuable', 'Very valuable', 'Extremely valuable'],
    canSkip: true,
    isAnswerPublic: true,
    isDefault: false,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 3,
    label: 'Did you take away something applicable?',
    type: 'rating',
    category: 'scale',
    description: 'Did you take away something you can apply immediately?',
    reportKey: 'immediate_application',
    options: ['Not really', 'Somewhat', 'Yes, definitely', 'Absolutely — already planning to'],
    canSkip: true,
    isAnswerPublic: true,
    isDefault: false,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 4,
    label: 'How engaged did you feel?',
    type: 'rating',
    category: 'scale',
    description: 'How engaged did you feel during the session?',
    reportKey: 'engagement_level',
    options: ['Not engaged', 'Somewhat engaged', 'Engaged', 'Deeply engaged', 'Completely absorbed'],
    canSkip: true,
    isAnswerPublic: true,
    isDefault: false,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 5,
    label: 'How relevant was this topic?',
    type: 'rating',
    category: 'scale',
    description: 'How relevant was this topic to your work, business, or life right now?',
    reportKey: 'topic_relevance',
    options: ['Not relevant', 'Somewhat relevant', 'Relevant', 'Highly relevant', 'Perfectly timed'],
    canSkip: true,
    isAnswerPublic: true,
    isDefault: false,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 6,
    label: 'What idea will stay with you?',
    type: 'text',
    category: 'text',
    description: "What's one idea, insight, or moment that will stay with you from this session?",
    reportKey: 'memorable_insight',
    canSkip: true,
    isAnswerPublic: true,
    isDefault: false,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 7,
    label: 'How likely to recommend?',
    type: 'rating',
    category: 'nps',
    description: 'How likely are you to recommend this speaker to others?',
    reportKey: 'recommendation_likelihood',
    options: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    canSkip: true,
    isAnswerPublic: true,
    isDefault: false,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 8,
    label: 'Describe speaker style',
    type: 'text',
    category: 'text',
    description: "If you had to describe this speaker's style in one word, what would it be?",
    reportKey: 'speaker_style',
    canSkip: true,
    isAnswerPublic: true,
    isDefault: false,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 9,
    label: 'Rating: Actionable',
    type: 'rating',
    category: 'star',
    description: "Was {{speakerName}}'s session actionable?",
    reportKey: 'rating_actionable',
    canSkip: true,
    isAnswerPublic: true,
    isDefault: false,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 10,
    label: 'Rating: Engaging',
    type: 'rating',
    category: 'star',
    description: "Was {{speakerName}}'s session engaging?",
    reportKey: 'rating_engaging',
    canSkip: true,
    isAnswerPublic: true,
    isDefault: false,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 11,
    label: 'Rating: Interactive',
    type: 'rating',
    category: 'star',
    description: "Was {{speakerName}}'s session interactive?",
    reportKey: 'rating_interactive',
    canSkip: true,
    isAnswerPublic: true,
    isDefault: false,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 12,
    label: 'Rating: Inspiring',
    type: 'rating',
    category: 'star',
    description: "Was {{speakerName}}'s session inspiring?",
    reportKey: 'rating_inspiring',
    canSkip: true,
    isAnswerPublic: true,
    isDefault: false,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 13,
    label: 'Rating: Relevant',
    type: 'rating',
    category: 'star',
    description: "Was {{speakerName}}'s session relevant?",
    reportKey: 'rating_relevant',
    canSkip: true,
    isAnswerPublic: true,
    isDefault: false,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 15,
    label: 'Collect title and org',
    type: 'contact',
    category: 'text',
    description: 'Your contact info (continued)',
    reportKey: 'collect_title_org',
    options: [
      { label: 'Ask for Title', inputLabel: 'Title', inputType: 'text', placeholder: 'Enter your job title', required: true },
      { label: 'Ask for Organization', inputLabel: 'Organization', inputType: 'text', placeholder: 'Enter your organization', required: true },
    ],
    canSkip: true,
    isAnswerPublic: false,
    isDefault: false,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 16,
    label: 'Opportunity Details',
    type: 'text',
    category: 'text',
    description: "Could you provide more details about the opportunity you're interested in booking {{speakerName}} for?",
    reportKey: 'opportunity_details',
    canSkip: true,
    isAnswerPublic: false,
    isDefault: false,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 17,
    label: 'Describe this talk',
    type: 'text',
    category: 'text',
    description: 'If you had to describe this session to a friend or colleague, what would you say?',
    reportKey: 'describe_talk',
    canSkip: true,
    isAnswerPublic: true,
    isDefault: false,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 18,
    label: 'What else?',
    type: 'text',
    category: 'text',
    description: 'What else should {{speakerName}} or the event organizer know?',
    reportKey: 'what_else',
    canSkip: true,
    isAnswerPublic: false,
    isDefault: false,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 19,
    label: 'Bonus',
    type: 'bonus',
    category: 'text',
    description: 'Do you want to give something to your audience?',
    reportKey: 'bonus',
    options: ['I want to give away a specific file or document (PDF, DOC, PNG)', 'I want to share a link (eg. a Dropbox link to multiple files)', 'I do not want to give away anything'],
    canSkip: true,
    isAnswerPublic: false,
    isDefault: false,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
  {
    priority: 20,
    label: 'Social & Meeting Links',
    type: 'social',
    category: 'text',
    description: 'How do you want your audience to keep in touch?',
    reportKey: 'social_meeting_links',
    options: [
      { label: 'Twitter', inputLabel: 'Twitter', inputType: 'text', placeholder: 'Enter your Twitter profile URL...', required: false },
      { label: 'Facebook', inputLabel: 'Facebook', inputType: 'text', placeholder: 'Enter your Facebook profile URL...', required: false },
      { label: 'Instagram', inputLabel: 'Instagram', inputType: 'text', placeholder: 'Enter your Instagram profile URL...', required: false },
      { label: 'Youtube', inputLabel: 'Youtube', inputType: 'text', placeholder: 'Enter your Youtube channel URL...', required: false },
      { label: 'LinkedIn', inputLabel: 'LinkedIn', inputType: 'text', placeholder: 'Enter your LinkedIn profile URL...', required: false },
      { label: 'Website', inputLabel: 'Website', inputType: 'text', placeholder: 'Enter your website URL...', required: false },
    ],
    canSkip: true,
    isAnswerPublic: true,
    isDefault: false,
    isMovable: true,
    hasBeenCustomized: false,
    isEnabled: true,
  },
];

export const questionTypeAndCategory = [
  { type: 'text', category: 'text', label: 'Open Ended', reportKey: 'text_question', options: null },
  { type: 'yes/no', category: 'boolean', label: 'Yes / No', reportKey: 'yes_no_question', options: ['Yes', 'No'] },
  { type: 'rating', category: 'star', label: 'Rating', reportKey: 'star_rating_question', options: null },
  { type: 'emoji', category: 'emoji', label: 'Emoji', reportKey: 'emoji_question', options: null },
  { type: 'rating', category: 'boolean', label: '5 Point Scale', reportKey: 'rating_question', options: ['Definitely Yes', 'Probably Yes', 'Probably Not', 'Definitely Not'] },
  { type: 'rating', category: 'scale', label: 'Scale Rating', reportKey: 'scale_rating_question', options: null },
  { type: 'rating', category: 'nps', label: 'NPS Scale', reportKey: 'nps_question', options: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'] },
  { type: 'booking', category: 'boolean', label: 'Booking', reportKey: 'booking_question', options: ['Yes', 'No', 'No, but I know someone who does!'] },
  // { type: 'booking', category: 'boolean', label: 'Booking', reportKey: 'booking_question', options: ['Yes, Yes within the next 6 months', 'No, Not at this time', 'Maybe, Yes but not sure when'] },
  { type: 'bonus', category: 'text', label: 'Bonus', reportKey: 'bonus_question', options: ['I want to give away a specific file or document (PDF, DOC, PNG)', 'I want to share a link (eg. a Dropbox link to multiple files)', 'I do not want to give away anything'] },
  {
    type: 'social',
    category: 'text',
    label: 'Social Links',
    reportKey: 'social_question',
    options: [
      { label: 'Twitter', inputLabel: 'Twitter', inputType: 'text', placeholder: 'Enter your Twitter profile URL...', required: false },
      { label: 'Facebook', inputLabel: 'Facebook', inputType: 'text', placeholder: 'Enter your Facebook profile URL...', required: false },
      { label: 'Instagram', inputLabel: 'Instagram', inputType: 'text', placeholder: 'Enter your Instagram profile URL...', required: false },
      { label: 'Youtube', inputLabel: 'Youtube', inputType: 'text', placeholder: 'Enter your Youtube channel URL...', required: false },
      { label: 'LinkedIn', inputLabel: 'LinkedIn', inputType: 'text', placeholder: 'Enter your LinkedIn profile URL...', required: false },
      { label: 'Website', inputLabel: 'Website', inputType: 'text', placeholder: 'Enter your website URL...', required: false },
    ],
  },
  {
    type: 'contact',
    category: 'text',
    label: 'Contact Info',
    reportKey: 'contact_question',
    options: [
      { label: 'Ask for Attendee Email', inputLabel: 'Email', inputType: 'email', placeholder: 'Enter your email', required: true },
      { label: 'Ask for Attendee Name', inputLabel: 'Name', inputType: 'text', placeholder: 'Enter your name', required: true },
      { label: 'Ask for Phone Number', inputLabel: 'Phone Number', inputType: 'tel', placeholder: 'Enter your phone number', required: false },
      { label: 'I am speaking to an audience under 18', placeholder: 'Email and Name disabled - please confirm you are over 18', required: false, isUnder18Option: true },
    ],
  },
  // {
  //   type: 'contact',
  //   category: 'text',
  //   label: 'Contact Info',
  //   reportKey: 'collect_title_org',
  //   options: [
  //    { label: 'Ask for Title', inputLabel: 'Title', inputType: 'text', placeholder: 'Enter your job title', required: true },
  //    { label: 'Ask for Organization', inputLabel: 'Organization', inputType: 'text', placeholder: 'Enter your organization', required: true },
  // ],
  // },
];

export const subscriptionPlans = [
  {
    name: 'starter',
    description: 'Perfect for getting started',
    price: 0,
    canAddCustomQuestions: false,
    canEditQuestions: false,
    numberOfCustomQuestions: 0,
  },
  {
    name: 'professional',
    description: 'For active speakers and trainers',
    price: 39,
    canAddCustomQuestions: true,
    canEditQuestions: true,
    numberOfCustomQuestions: 10,
  },
  {
    name: 'enterprise',
    description: 'For organizations and teams',
    price: 99,
    canAddCustomQuestions: true,
    canEditQuestions: true,
    numberOfCustomQuestions: 25,
  },
];
